import workspaceQuery from '../../../graphql/queries/sales/WooCommerceConfigurationWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/WooCommerceConfigurationListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/WooCommerceConfigurationQuery.graphql';
import defaultQuery from '../../../graphql/queries/sales/WooCommerceConfigurationDefault.graphql';
import mutationQuery from '../../../graphql/mutations/sales/WooCommerceConfigurationMutation.graphql';
import fragment from '../../../graphql/fragments/sales/WooCommerceConfigurationFragment.graphql';
import { ALLOW_ADD, ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const WooCommerceConfiguration: EntityType = {
  type: 'WooCommerceConfiguration',
  title: 'WooCommerce Configurations',
  formTitle: 'WooCommerce Configuration',
  formUrl: '/Sales/Channel/WooCommerceConfig/Details/',
  workspaceUrl: '/Sales/Channel/WooCommerceConfig/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'SALES_WOOCOMMERCE_CONFIG',
  operations: ALLOW_ADD | ALLOW_EDIT | ALLOW_VIEW,
};

export default WooCommerceConfiguration;
